import { InboxContext } from '../types';
import { setExternalCallToAbandoned } from '../callHandlers/externalCalls';
import { ServiceSessionEvent } from '@modules/ServiceModule/workspace/types/ServiceEvents';
import TasksModule from '@modules/TasksModule';
import { TaskState } from '@modules/TasksModule/types';

function handleSessionDeleted(
  context: InboxContext,
  event: ServiceSessionEvent,
) {
  // we should be getting a rescinded event from kazoo
  // when a customer hangs up prior to an agent
  // accepting, but we just get this. For now, treat it
  // like an abandoned event unless it is accepted or
  // timed out. Session deleted event is still emitted
  // for accepted and timed out calls but we don't want
  // to treat them as abandoned.

  const task = TasksModule.getTask(event.sessionSid);

  if (task && task.state === TaskState.Offered) {
    setExternalCallToAbandoned(context, event.sessionSid);
  }
}

export default handleSessionDeleted;
